import React from 'react';
import { Language } from '../types/language';

interface Props {
  currentLanguage: Language;
  onLanguageChange: (language: Language) => void;
}

export function LanguageToggle({ currentLanguage, onLanguageChange }: Props) {
  const languages = {
    en: { flag: '🇬🇧', label: 'English' },
    fr: { flag: '🇫🇷', label: 'Français' }
  };

  return (
    <div className="flex justify-center gap-2 mt-4">
      {Object.entries(languages).map(([code, { flag, label }]) => (
        <button
          key={code}
          onClick={() => onLanguageChange(code as Language)}
          className={`flex items-center px-3 py-2 rounded-lg transition-all duration-200 ${
            currentLanguage === code
              ? 'bg-blue-100 text-blue-700'
              : 'bg-white hover:bg-gray-50 text-gray-700'
          } shadow-sm`}
          aria-label={`Switch to ${label}`}
        >
          <span className="text-xl mr-2" role="img" aria-label={`${label} flag`}>
            {flag}
          </span>
          <span className="text-sm font-medium">{label}</span>
        </button>
      ))}
    </div>
  );
}